"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles = __importStar(require("./RemainingChars.module.css"));
var RemainingChars = (function (_super) {
    __extends(RemainingChars, _super);
    function RemainingChars(props) {
        return _super.call(this, props) || this;
    }
    RemainingChars.prototype.render = function () {
        var _a = this.props, maxLength = _a.maxLength, value = _a.value;
        return (react_1.default.createElement("div", { className: styles.root },
            react_1.default.createElement("span", { className: styles.counter },
                react_1.default.createElement("strong", null, value.length)),
            " ",
            react_1.default.createElement("span", null, " / "),
            " ",
            react_1.default.createElement("span", null,
                react_1.default.createElement("strong", null, maxLength)),
            " ",
            react_1.default.createElement("span", null, "characters remaining")));
    };
    return RemainingChars;
}(react_1.Component));
exports.RemainingChars = RemainingChars;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUmVtYWluaW5nQ2hhcnMuanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9jb21wb25lbnRzL1JlbWFpbmluZ0NoYXJzL1JlbWFpbmluZ0NoYXJzLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsNkNBQXNDO0FBQ3RDLGtFQUFxRDtBQU9yRDtJQUFvQyxrQ0FBb0I7SUFDcEQsd0JBQVksS0FBSztlQUNiLGtCQUFNLEtBQUssQ0FBQztJQUNoQixDQUFDO0lBQ00sK0JBQU0sR0FBYjtRQUNVLElBQUEsZUFBK0IsRUFBOUIsd0JBQVMsRUFBRSxnQkFBbUIsQ0FBQTtRQUVyQyxPQUFPLENBQ0gsdUNBQUssU0FBUyxFQUFFLE1BQU0sQ0FBQyxJQUFJO1lBQ3ZCLHdDQUFNLFNBQVMsRUFBRSxNQUFNLENBQUMsT0FBTztnQkFDM0IsOENBQVUsS0FBZ0IsQ0FBQyxNQUFNLENBQVUsQ0FDeEM7WUFBQyxHQUFHO1lBQ1gsa0RBQWdCO1lBQUMsR0FBRztZQUNwQjtnQkFDSSw4Q0FBUyxTQUFTLENBQVUsQ0FDekI7WUFBQyxHQUFHO1lBQ1gsNENBQU8sc0JBQXNCLENBQVEsQ0FDbkMsQ0FDVCxDQUFBO0lBQ0wsQ0FBQztJQUNMLHFCQUFDO0FBQUQsQ0FBQyxBQXBCRCxDQUFvQyxpQkFBUyxHQW9CNUM7QUFwQlksd0NBQWMifQ==